import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Order } from '../../interfaces/orders/order';
import { UltimateBeneficialOwnershipRequestDocument } from '../../interfaces/ultimate-beneficial-ownership-request-documents/ultimate-beneficial-ownership-request-document';
import { DocumentsRepositoryService } from '../../services/document/documents-repository.service';
import { eDocumentType } from '../../enums';
import { base64StringToBlob } from 'blob-util';

@Component({
    selector: 'lib-ubo-supporting-business-documents',
    templateUrl: './ubo-supporting-business-documents.component.html',
    styleUrls: [
        './ubo-supporting-business-documents.component.css',
        './../../../results-page.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UboSupportingUsinessDocumentsComponent {
  @Input() public order!: Order;

  displayedDocColumns = ['name', 'type', 'file-name', 'actions'];

  private _downloading = new Set<string>();

  constructor(private documentsRepo: DocumentsRepositoryService) {}

  isDownloading(id: string | undefined): boolean {
    if (!id) return false;
    return this._downloading.has(id);
  }

  onRowDownload(rowId: string) {
    const row = this.findRequestRow(rowId);
    const docId = row?.document?.id;
    if (!docId) return;

    this._downloading.add(rowId);

    this.documentsRepo.getDocument(docId).subscribe({
      next: (result) => {
        const typeId = (result?.documentTypeID || 'PDF').toString().toLowerCase();

        // Map to MIME using your enum
        const mimeMap: Record<string, string> = {
          [eDocumentType.pdf]:  'application/pdf',
          [eDocumentType.json]: 'application/json',
          [eDocumentType.xml]:  'application/xml',
          [eDocumentType.html]: 'text/html',
          [eDocumentType.csv]:  'text/csv',
          [eDocumentType.text]: 'text/plain'
        } as any;

        const mime = mimeMap[typeId] ?? 'application/pdf';

        const blob = base64StringToBlob(result.base64, mime);
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = row?.document?.fileName || `document.${typeId}`;
        a.click();
        URL.revokeObjectURL(url);

        this._downloading.delete(rowId);
      },
      error: () => {
        this._downloading.delete(rowId);
      }
    });
  }

  private findRequestRow(id: string): UltimateBeneficialOwnershipRequestDocument | undefined {
    return this.order.ultimateBeneficialOwnershipRequest?.documents
      ?.find(d => d.id === id);
  }
}